import React from "react";
import { aiDigitalTypeChangeitems, DigitalTypeConfig } from "../../config";
import qiehuanIcon from "../../../../static/qiehuan.svg";
import ActiveBtn from "../activeBtn";
import "./index.less";
const Select = ({ value, onChange, setShow, show, open, setOpen }) => {
  return (
    <>
      <ActiveBtn icon={qiehuanIcon} show={!open}>
        场景切换
        <input
          className="digital-select-value"
          value=""
          onFocus={() => {
            setOpen(true);
            setShow(true);
          }}
          onBlur={() => {
            setTimeout(() => {
              setOpen(false);
              setShow(false);
            }, 0);
          }}
        />
      </ActiveBtn>
      <div
        className="digital-select-modal"
        style={{ opacity: show ? 1 : 0, width: show ? "80vw" : "0vw" }}
        onClick={() => {
          if (!show) {
            return;
          }
        }}
      >
        {aiDigitalTypeChangeitems.map((item) => {
          return (
            <div
              className={`select-modal-item ${
                item.value === value ? "select-modal-item-current" : ""
              } ${
                !DigitalTypeConfig[item.value]
                  ? "select-modal-item-disable"
                  : ""
              }`}
              onClick={() => {
                if (!DigitalTypeConfig[item.value]) {
                  return;
                }
                onChange(item.value);
              }}
            >
              <div style={{ width: "60%" }}> {item.label}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Select;
